const faqData = [
  {
    title: 'What are derivatives?',
    content:
      'A contract which derives its value from the prices, or index of prices, of underlying securities.'
  },
  {
    title: 'What is a futures contract?',
    content:
      'A futures contract is a legally binding agreement to buy or sell the underlying security in the future.'
  },
  {
    title: 'What is type of option?',
    content: 'Type of option means the classification of an option as either a ‘Put’ or a ‘Call’.'
  },
  {
    title: 'What is exercise style?',
    content:
      'Exercise style of an option refers to the price at which and/or time as to when the option is exercisable by the holder. It may either be an American style option or an European style option or such other exercise style of option as the relevant authority (stock exchange) may prescribe from time to time.'
  },
  {
    title: 'What is a European style option contract?',
    content:
      'European style option contract is an option contract which may be exercised on the expiration day on or before the expiration time.'
  }
];

export default faqData;
